import { GLOBAL_DATE_FORMATS } from "constants/date.constants";
import moment from "moment/moment";


const getStringDateAvailableUntil = ({ bonus }) => {
	return moment.utc(bonus.endDate).local().format(GLOBAL_DATE_FORMATS.LOCALE).replaceAll("/", ".");
};

export default getStringDateAvailableUntil;
